/**
 * useInstructorCVPhoto.js
 *
 * Eğitmen tarafında CV fotoğrafını auth header ile fetch edip object URL (blob) döndüren hook.
 * Cleanup'ta revokeObjectURL çağrılır. Foto yoksa null döndürür (template placeholder gösterir).
 *
 * @param {string|null} cvProfileId - İncelenen CV profilinin ID'si
 * @param {string|null} fotoUrl    - detail.merged?.foto_url veya detail.original?.foto_url
 *                                    (truthy olduğunda fetch tetiklenir)
 * @returns {string|null} blobUrl  - <img src> için hazır object URL, ya da null
 */

import { useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useInstructorCVPhoto(cvProfileId, fotoUrl) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    // Foto yoksa veya cvProfileId yoksa — null bırak
    if (!fotoUrl || !cvProfileId) {
      setBlobUrl(null);
      return;
    }

    let cancelled = false;
    let objectUrl = null;

    const fetchPhoto = async () => {
      try {
        const token = getToken();
        const res = await axios.get(
          `${API}/instructor/cv/${cvProfileId}/photo`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            responseType: 'blob',
          }
        );
        if (!cancelled) {
          objectUrl = URL.createObjectURL(res.data);
          setBlobUrl(objectUrl);
        }
      } catch {
        // Foto erişilemiyor (silindi, 404, vs.) — placeholder göster
        if (!cancelled) setBlobUrl(null);
      }
    };

    fetchPhoto();

    return () => {
      cancelled = true;
      // Revoke the blob URL when cvProfileId/fotoUrl changes or component unmounts
      setBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
    };
  }, [cvProfileId, fotoUrl]);

  return blobUrl;
}
